import React, { createElement, Component } from 'react';
import css from './button.scss';
import { pick } from 'helpers';
import { Link } from 'components';

export function Button(props) {
  if (props.href) {
    return (
      <a {...props} className={className(props)} />
    );
  }
  return createElement(props.to ? Link : 'button', {
    ...pick(props, 'children', 'style', 'onClick', props.to ? 'to': ''),
    className: className(props),
  });
}

function className(props) {
  return [
    css.button,
    props.className,
    props.primary && css.primary,
    props.square && css.square,
    props.unfilled && css.unfilled,
    props.white && css.white,
    props.blue && css.blue,
  ].join(' ');
}
